<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        {{ headline }}
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="$emit('submit', data)">
        <TextFormGroup
            v-model="data.name"
            name="name"
            label="Name"
            help-text="The name of the article category."
            :error="(errors.name || [])[0]"
        />

        <TextFormGroup
            v-model="data.path"
            name="path"
            label="Path"
            help-text="The path of the article category."
            :error="(errors.path || [])[0]"
        />

        <TextFormGroup
            v-model="data.description"
            name="description"
            label="Description"
            help-text="The description of the article category."
            :error="(errors.description || [])[0]"
        />

        <RadioFormGroup
            v-if="edit"
            v-model="data.is_active"
            name="is_active"
            label="Active"
            help-text="A flag indicating if the article category is active."
            :error="(errors.is_active || [])[0]"
            :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
        />

        <SubmitFormGroup button-class="btn-black"/>
      </form>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import RadioFormGroup from '@/vendor/forms/FormGroups/Block/Radio'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {RadioFormGroup, SubmitFormGroup, TextFormGroup,},

  props: {
    headline: {
      required: true,
      type: String
    },

    initial: {
      required: false,
      type: Object,
      default: () => ({})
    },

    errors: {
      required: true,
      type: Object
    },

    edit: {
      required: false,
      default: false
    }
  },

  data() {
    return {
      data: {...this.initial},

      shared: store
    }
  }
}
</script>